/* collection-gemstone-t3.js: scripts that used to be inline in sections/main-collection-product-grid-gemstone-t3.liquid.
   Moved to a cached asset (Oct 2026); contents unchanged, in the original order. Each block is marked with
   the line it came from in that file at the time of the move. */

/* ---- from main-collection-product-grid-gemstone-t3.liquid line 2618 ---- */
  function swymCallbackFn(swat){

    // your API calls go here
    document.addEventListener("swym:collections-loaded", function(){
        swat.initializeActionButtons(".ajax_popup"); 
       swat.initializeActionButtons("#Huratips-Loop");

    })
  }
  if(!window.SwymCallbacks){
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(swymCallbackFn);

/* ---- from main-collection-product-grid-gemstone-t3.liquid line 2634 ---- */
 $(document).ready(function() {

 var getFilterByLen = $('li.filter-selected').length;
          
                  if(getFilterByLen > 0){
                var getFilterBy = $('.filter_by_icon h3.filter_byh3').text();
                getFilterBy = `${getFilterBy} (${getFilterByLen})`;
                $('.filter_by_icon h3.filter_byh3').text(getFilterBy);
                  var getFilterBy1 = $('span.custom_filters_heading').text();
                  getFilterBy1 = `Filters (${getFilterByLen})`;
                $('span.custom_filters_heading').text(getFilterBy1);
                    }
   
    function initSlick() {
        if (window.innerWidth < 768) {
            if (!$('.slidergem.slider-productsgem').hasClass('slick-initialized')) {
              setTimeout(function(){ 
                $('.slidergem.slider-productsgem').slick({
                    dots: true,
                    arrows:false,
                    infinite: true,
                    dotsClass: 'custom_paging'
                });
                },500);
            }
        } else {
            if ($('.slidergem.slider-productsgem').hasClass('slick-initialized')) {
                $('.slidergem.slider-productsgem').slick('unslick');
            }
        }
    }

    // Initialize slick on page load
    initSlick();

    // Reinitialize slick on window resize
    $(window).on('resize', function() {
        initSlick();
    });
});
 

/* ---- from main-collection-product-grid-gemstone-t3.liquid line 2677 ---- */
$(document).ready(function(){
  sliderInitfunc();
  function getRandomInt(min, max) {
        min = Math.ceil(min);   // Round up to the nearest integer
        max = Math.floor(max);  // Round down to the nearest integer
        return Math.floor(Math.random() * (max - min + 1)) + min;  // Generate random integer
    }

  
 
var randomNumber = getRandomInt(1, 3);

  
$('.cust_animated_wrapper').addClass('is-active');
$(`.custom_animattion_div_${randomNumber}`).show(); 
    setTimeout(function() {
        $(`.custom_animattion_div_${randomNumber}`).hide();
        $('.cust_animated_wrapper').removeClass('is-active');
    }, 5000);
  $(window).scroll(function() {
    
if($('.cust_animated_wrapper').hasClass('is-active')){

}else{
var randomNumber0 = getRandomInt(30, 45);
var randomNumber1 = getRandomInt(45, 60);
var randomNumber2 = getRandomInt(35, 80);
var randomNumber3 = getRandomInt(40, 90);
var randomNumber4 = getRandomInt(5, 25);
var randomNumber5 = getRandomInt(25, 50);
var randomNumber6 = getRandomInt(50, 75);
var randomNumber7 = getRandomInt(75, 90);  
var randomNumber = getRandomInt(1, 3);

$('.cust_animated_wrapper .cstm_zoom_anim_1').css('top',randomNumber0+'%');
$('.cust_animated_wrapper .cstm_zoom_anim_2').css('top',randomNumber1+'%');
$('.cust_animated_wrapper .cstm_zoom_anim_3').css('top',randomNumber2+'%');
$('.cust_animated_wrapper .cstm_zoom_anim_4').css('top',randomNumber3+'%');
$('.cust_animated_wrapper .cstm_zoom_anim_1').css('left',randomNumber4+'%');
$('.cust_animated_wrapper .cstm_zoom_anim_2').css('left',randomNumber5+'%');
$('.cust_animated_wrapper .cstm_zoom_anim_3').css('left',randomNumber6+'%');
$('.cust_animated_wrapper .cstm_zoom_anim_4').css('left',randomNumber7+'%');
  
$(`.custom_animattion_div_${randomNumber}`).show();  
$('.cust_animated_wrapper').addClass('is-active');
   
 // $('.cust_animated_wrapper').css("visibility", "visible");
  setTimeout(function() {
    $(`.custom_animattion_div_${randomNumber}`).hide();
  $('.cust_animated_wrapper').removeClass('is-active');
  //  $('.cust_animated_wrapper').css("visibility", "hidden");
    }, 5000);
}
});



  
  $('body').on('click','span.mobile-facets__open-label.button-label',function () {
     setTimeout(function(){
     
           if($('.mobile-facets__disclosure').hasClass('menu-opening')){
                $('div#shopify-section-header').addClass('is-filters-active');
               $('body').addClass('is-filters-active');
               $('.facets-wrapper').addClass('is-filters-active');
          }
           else{
            } 
     },100)
});
  
var getLenght = $('p.custom_price_hide_show').length;
   setTimeout(function() {
    // alert();
  if(getLenght > 0){
    $('.main_price_zoom_container .price1.precioCollection.priceVisible').show();
}else{
 $('.main_price_zoom_container .price1.precioCollection.priceVisible').hide();
  }
 }, 2000);

      $('body').on('click','.custom_toggle_button label',function () {
        setTimeout(function() {
              if($('.custom_toggle_button input[type="checkbox"]').is(":checked")){
                  $('.cust_animated_wrapper').css("visibility", "hidden");
                localStorage.setItem('input_box','false');
              }else{
                  $('.cust_animated_wrapper').css("visibility", "visible");
                 localStorage.setItem('input_box','true');
              }
          }, 100);
      })
  

 var getLoaclval = localStorage.getItem('input_box','true');

if(getLoaclval == 'false'){
  $('.custom_toggle_button input[type="checkbox"]').attr('checked','checked');
   $('.cust_animated_wrapper').css("visibility", "hidden");
}else{
   $('.custom_toggle_button input[type="checkbox"]').removeAttr('checked','checked');
   $('.cust_animated_wrapper').css("visibility", "visible");
}
    $('body').on('click',' menu-drawer.mobile-facets__wrapper svg.icon.icon-close',function () {
    
      
  let params = [];

    let selectedFilters = document.querySelectorAll('li.filter-selected input');
if(selectedFilters.length != '0'){
    selectedFilters.forEach((filter) => {
        let paramName = filter.name;
        let paramValue = filter.value;

        // Add each key-value pair to the params array as a separate string
        params.push(`${paramName}=${paramValue}`);
    });

    var $input = $('#Mobile-Filter-Price-GTE');
     if ($input.val()) {
       var value = $input.val();
       var name = $input.attr('name');
       params.push(`${name}=${value}`);
    }

  var $input = $('#Mobile-Filter-Price-LTE');
     if ($input.val()) {
       var value = $input.val();
       var name = $input.attr('name');
       params.push(`${name}=${value}`);
    }
  

    let currentUrl = window.location.href;
    let cleanedUrl = currentUrl.split('?')[0];
    let cleanedUrl1 = currentUrl.split('?')[1];
    let queryString = params.join('&');

    var finalUrl = cleanedUrl + '?' + queryString;

        if(cleanedUrl1 == queryString){
            setTimeout(function(){
          if($('.mobile-facets__disclosure').hasClass('menu-opening')){
          
          }else{
             $('body').removeClass('is-filters-active');
            $('div#shopify-section-header').removeClass('is-filters-active');
            $('.facets-wrapper').removeClass('is-filters-active');
          }
        },1000)
          } else {
            var selectedVal = $('input[type="checkbox"]:checked').val();
           if (selectedVal !== undefined) {
  
                if(selectedVal == "Natural" ){
                  var querynatural = 'filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122614920&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122418312&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122680456&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78221148296';
                  var finalUrlNatural  = finalUrl + '&' + querynatural;
                window.location.href = finalUrlNatural; 
                } else if(selectedVal == "Lab+Grown"){
                 var queryLab = 'filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78225571976&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122549384&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122614920&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122680456';
                  var finalUrlLab  = finalUrl + '&' + queryLab;
                window.location.href = finalUrlLab; 
                } else{
                  window.location.href = finalUrl;  
                }
                  
              } else{
               window.location.href = finalUrl; 
              }
          }
  } else{ 
      

      
       setTimeout(function(){
          if($('.mobile-facets__disclosure').hasClass('menu-opening')){
          
          }else{
            $('body').removeClass('is-filters-active');
            $('div#shopify-section-header').removeClass('is-filters-active');
            $('.facets-wrapper').removeClass('is-filters-active');
          }
        },1000)

  } 
      });
  
  $(document).on("click", function(e) {
    setTimeout(function(){
        if ($(e.target).is(".is-filters-active .custom_combine_coll_prd_factes.facets-container .mobile-facets__inner") === false) {
            if($('.mobile-facets__disclosure').hasClass('menu-opening')){
         
            }else{
 
        let params = [];
        let selectedFilters = document.querySelectorAll('li.filter-selected input');
        if(selectedFilters.length != '0'){
            selectedFilters.forEach((filter) => {
                let paramName = filter.name;
                let paramValue = filter.value;
        
                // Add each key-value pair to the params array as a separate string
                params.push(`${paramName}=${paramValue}`);
            });
    var $input = $('#Mobile-Filter-Price-GTE');
     if ($input.val()) {
       var value = $input.val();
       var name = $input.attr('name');
       params.push(`${name}=${value}`);
    }

  var $input = $('#Mobile-Filter-Price-LTE');
     if ($input.val()) {
       var value = $input.val();
       var name = $input.attr('name');
       params.push(`${name}=${value}`);
    }
  
            let currentUrl = window.location.href;
            let cleanedUrl = currentUrl.split('?')[0];
             let cleanedUrl1 = currentUrl.split('?')[1];
            let queryString = params.join('&');
        
            var finalUrl = cleanedUrl + '?' + queryString;

          if(cleanedUrl1 == queryString){
               $('body').removeClass('is-filters-active');
               $('div#shopify-section-header').removeClass('is-filters-active');
               $('.facets-wrapper').removeClass('is-filters-active');
          } else {
          var selectedVal = $('input[type="checkbox"]:checked').val();
           if (selectedVal !== undefined) {
  
                if(selectedVal == "Natural" ){
                  var querynatural = 'filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122614920&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122418312&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122680456&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78221148296';
                  var finalUrlNatural  = finalUrl + '&' + querynatural;
               // window.location.href = finalUrlNatural; 
                } else if(selectedVal == "Lab+Grown"){
                 var queryLab = 'filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78225571976&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122549384&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122614920&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122680456';
                  var finalUrlLab  = finalUrl + '&' + queryLab;
                window.location.href = finalUrlLab; 
                } else{
              //    window.location.href = finalUrl;  
                }
                  
              } else{
              // window.location.href = finalUrl; 
              }
  
          }
          } else{ 
              $('body').removeClass('is-filters-active');
              $('div#shopify-section-header').removeClass('is-filters-active');
              $('.facets-wrapper').removeClass('is-filters-active');
            } 


              
          }
        }
       },1000)
    });

if ($('.jtpl-pro-variant-cstm').hasClass('slick-initialized')) {
 $('.jtpl-pro-variant-cstm').slick('unslick'); 
 } 
})


$('body').on('click','div#shop_the_image_jtpl_banner1',function () {
  $(".contentFoto.jtpl_collection_prd_pop_up").addClass("show_pop_shop_look_jtpl1");
});



function sliderInitfunc() { 
if ($('.slider.slider-products:not(.ts-snap)').hasClass('slick-initialized')) {
     $('.slider.slider-products:not(.ts-snap)').slick("unslick"); 
}
  setTimeout(function() {
    $('.slider.slider-products:not(.ts-snap)').slick({
        dots: true,
        infinite: true,
        responsive: [{
            breakpoint: 1024,
            settings: {
                infinite: true,
                dotsClass: 'custom_paging'
            }
        }]
  
    });
  },100 );

}

function myfunction1(){
// img_load()
//   slick_swap()
$('.slider.slider-products:not(.slick-initialized):not(.ts-snap)').slick({
          dots: true,
          infinite: true,
          responsive: [
          {
            breakpoint: 1024,
            settings: {
             infinite: true,
              dotsClass: 'custom_paging'
             }
          }
        ]    
    });

  $('.popup_gemstone_data ul:not(.slick-initialized)').slick({
        dots: false,
        infinite: false,
        slidesToShow: 5.5,
        slidesToScroll: 3,
     responsive: [
          {
            breakpoint: 767,
            settings: {
            infinite: false,
            slidesToShow: 1.5,
            slidesToScroll: 1,
            }   
          }
        ]
    });


$(".cstm-hide-select option").each(function() {
var qntyship = $(this).data('qntylessship');
var price = $(this).data('pricee');
var qnty = $(this).data('qnty');
var attrpid = $(this).data('attrpid');  
var skipDates = $('.skipDatesMeta').text();
var qnty_less_data_meta = $('.qnty_less_data_meta').text();
    
if(qntyship == null){
   var qnty_less_data = qnty_less_data_meta;
  } else{
  var qnty_less_data = qntyship;       
 } 


  
let wizardInfo = localStorage.getItem('wizardInfo');
if(wizardInfo){
let vendorName = JSON.parse(wizardInfo);
    if(vendorName.vendor_name != undefined || vendorName.vendor_name != null ){
           var url = window.API_URL + `diamonds/diamondShipping/singlevendorShowShipping/${vendorName}`;
        
        var settings = {
          "url": url,
          "method": "GET",
          "timeout": 0,
          "headers": {
          "X-API-Key": "TSANITY121A3VG7NEMVRXXEWGM"
          },
        };
        
        $.ajax(settings).done(function (response) {
        var vendor_Shipping_date = response.shipping_date;

         if(qnty_less_data_meta > vendor_Shipping_date){
          if(qntyship == null){
             var qnty_less_data = qnty_less_data_meta;
            } else{
            var qnty_less_data = qntyship;       
           }  
         }  else{
          
          var qnty_less_data = vendor_Shipping_date;
             
         }
          
        
        });
    }
} 
if(qnty_less_data == 0){
           qnty_less_data_updated = parseInt(qnty_less_data) + 1;
         } else{
           qnty_less_data_updated = qnty_less_data;
         }
              var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
              "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"
            ];
            
            let today = new Date();
            var pstDate = today.toLocaleString("en-US", { timeZone: "America/New_York" });
            let hh = new Date(pstDate).getHours();
           
             
             if(hh > 15){
               if(qnty_less_data == 0){
              var dd = today.getDate() + 1 ; 
               } else{
               var dd = today.getDate() + 2 ;  
               }
               
             }  else{
               if(qnty_less_data == 0){
              var dd = today.getDate(); 
               } else{
               var dd = today.getDate() + 1 ;  
               }
             }
             
            let mm = today.getMonth() + 1;
            let yyyy = today.getFullYear();
            
            var startDate = yyyy + '/' + mm + '/' + dd;
            startDate = new Date(startDate);
            
            var startDateRange = yyyy + '/' + mm + '/' + dd;
            startDateRange = new Date(startDateRange);

            var startDateOUtUs = yyyy + '/' + mm + '/' + dd;
            startDateOUtUs = new Date(startDateOUtUs); 
            var endDate = "";
            var endDateoutus = "";
            var endDateRange = "";

            var country_loc = localStorage.getItem("countryus");
        
              if(country_loc == 'yes'){
                 
                if(price < 251 ){
                  
                    if(qnty_less_data == 0){
                      var noOfDaysToAdd = parseInt(qnty_less_data_updated) + 2 ; 
                     var noOfDaysToAddrange = parseInt(qnty_less_data_updated) + 5 ; 
                   } else{
                       var noOfDaysToAdd = parseInt(qnty_less_data_updated) + 2 ; 
                     var noOfDaysToAddrange = parseInt(qnty_less_data_updated) + 5 ; 
                   }   
                     
                    
                } else{
                  
                  if(qnty_less_data == 0){
                     var noOfDaysToAdd = parseInt(qnty_less_data_updated) + 1 ;
                     var noOfDaysToAddrange = parseInt(qnty_less_data_updated) + 4 ; 




 

       
                   } else{
                      var noOfDaysToAdd = parseInt(qnty_less_data_updated) + 2 ;
                     var noOfDaysToAddrange = parseInt(qnty_less_data_updated) + 5 ; 
                   }   
                     
                }  
            } else{
             
             if(qnty_less_data == 0){
                      var noOfDaysToAddoutusa = parseInt(qnty_less_data_updated) + 1;  
                   } else{
                      var noOfDaysToAddoutusa = qnty_less_data_updated; 
                   }   
              }
               
          
            var countoutus = 0;
            while(countoutus < noOfDaysToAddoutusa ){
                endDateoutus = new Date(startDateOUtUs.setDate(startDateOUtUs.getDate() + 1)); 
               if (skipDates.includes(endDateoutus.toISOString().substring(0, 10))) {
                   continue;
              }
              if (endDateoutus.getDay() != 0 && endDateoutus.getDay() != 6 &&  !skipDates.includes(startDateOUtUs.toISOString().substring(0, 10))) {

                  countoutus++;
                }
             }
            
            var count = 0;
            while(count < noOfDaysToAdd ){
                endDate = new Date(startDate.setDate(startDate.getDate() + 1)); 
               if (skipDates.includes(endDate.toISOString().substring(0, 10))) {
                   continue;
              }
              if (endDate.getDay() != 0 && endDate.getDay() != 6 &&  !skipDates.includes(startDate.toISOString().substring(0, 10))) {
                 
                  count++;
                }
             }

              var count1 = 0;
              while(count1 < noOfDaysToAddrange ){
                endDateRange = new Date(startDateRange.setDate(startDateRange.getDate() + 1)); 
               if (skipDates.includes(endDateRange.toISOString().substring(0, 10))) {
                   continue;
              }
              if (endDateRange.getDay() != 0 && endDateRange.getDay() != 6 &&  !skipDates.includes(startDateRange.toISOString().substring(0, 10))) {
                  
                  count1++;
                }
             }
       
            var weekday = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];   
           
            
              
               var country_loc = localStorage.getItem("countryus");
           
              
                if(country_loc == "yes") {
                  console.log("<<<<<<<<<<<<<<<,inside this>>>>>>>>>>>>>>>");
                    var newDateRange =  new Date(endDateRange.getTime());

                    var newDaten =  new Date(endDateRange.getTime() + (1 * 86400000));
                      var skipDates = $('.skipDatesMeta').text();
                     
                       var dateString = newDaten.toISOString().slice(0, 10);
                    
                       if (skipDates.includes(dateString)) {
                      
                          var newDateRange =  new Date(endDateRange.getTime() + (1 * 86400000));
                          var newDatett =  new Date(endDateRange.getTime() + (2 * 86400000));   
                          var dateString2 = newDatett.toISOString().slice(0, 10);
                         if (skipDates.includes(dateString2)) {
                              var newDateRange =  new Date(endDateRange.getTime() + (2 * 86400000));
                         
                             var newDatettt =  new Date(endDateRange.getTime() + (3 * 86400000));
                             var dateString3 = newDatettt.toISOString().slice(0, 10);
                        
                             if (skipDates.includes(dateString3)) {
                               
                               var newDateRange =  new Date(endDateRange.getTime() + (3 * 86400000));
                               var newDatettttt =  new Date(endDateRange.getTime() + (4 * 86400000));
                                 var dateString4 = newDatettttt.toISOString().slice(0, 10);
                                if (skipDates.includes(dateString4)) {
                                var newDateRange =  new Date(endDateRange.getTime() + (4 * 86400000));
                                }  
                             }
                         }
                        }
                 
                   var newDate =  new Date(endDate.getTime());
            
                    var newDaten =  new Date(endDate.getTime() + (1 * 86400000));
                      var skipDates = $('.skipDatesMeta').text();
                     
                       var dateString = newDaten.toISOString().slice(0, 10);
                    
                       if (skipDates.includes(dateString)) {
                         
                      
                          var newDate =  new Date(endDate.getTime() + (1 * 86400000));
                          var newDatett =  new Date(endDate.getTime() + (2 * 86400000));   
                          var dateString2 = newDatett.toISOString().slice(0, 10);
                         if (skipDates.includes(dateString2)) {
                              var newDate =  new Date(endDate.getTime() + (2 * 86400000));
                         
                             var newDatettt =  new Date(endDate.getTime() + (3 * 86400000));
                             var dateString3 = newDatettt.toISOString().slice(0, 10);
                        
                             if (skipDates.includes(dateString3)) {
                               
                               var newDate =  new Date(endDate.getTime() + (3 * 86400000));
                               var newDatettttt =  new Date(endDate.getTime() + (4 * 86400000));
                                 var dateString4 = newDatettttt.toISOString().slice(0, 10);
                                if (skipDates.includes(dateString4)) {
                                var newDate =  new Date(endDate.getTime() + (4 * 86400000));
                                }  
                             }
                         }
                        }
                          
            
                              var newddRange = newDateRange.getDate();
                              var newmmRange = newDateRange.getMonth() + 1;
                              let dayRange = weekday[newDateRange.getDay()];
                             
                                  
                              var newdd = newDate.getDate();
                              var newmm = newDate.getMonth() + 1;
                              let day = weekday[newDate.getDay()];

                           if(newdd == "1" || newdd == "21" || newdd == "31"){
                                var dayt = newdd+'st';
                              } else if(newdd == "2" || newdd == "22"){
                                 var dayt = newdd+'nd';
                              } else if(newdd == "3" || newdd == "33"){
                                var dayt = newdd+'rd';
                              } else{
                                var dayt = newdd+'th';
                              }

                            if(newddRange == "1" || newddRange == "21" || newddRange == "31"){
                                var daytrange = newddRange+'st';
                              } else if(newddRange == "2" || newddRange == "22"){
                                 var daytrange = newddRange+'nd';
                              } else if(newddRange == "3" || newddRange == "33"){
                                var daytrange = newddRange+'rd';
                              } else{
                                var daytrange = newddRange+'th';
                              }

                            if(price < 251 ){
                               var finalDate = day+', '+monthNames[newDate.getMonth()] + ' ' +newdd +' - '+dayRange+', '+monthNames[newDateRange.getMonth()] + ' ' +daytrange;
                            } else{
                              var finalDate = day+', '+monthNames[newDate.getMonth()] + ' ' +dayt ;
                            }  
                 
                            var text = document.createTextNode(finalDate);
                                  
                  
                } else{
            
             
                   var newDate =  new Date(endDateoutus.getTime());
           
                    var newDaten =  new Date(endDateoutus.getTime() + (1 * 86400000));
                      var skipDates = $('.skipDatesMeta').text();
                     
                       var dateString = newDaten.toISOString().slice(0, 10);
                    
                       if (skipDates.includes(dateString)) {
                      
                          var newDate =  new Date(endDateoutus.getTime() + (1 * 86400000));
                          var newDatett =  new Date(endDateoutus.getTime() + (2 * 86400000));   
                          var dateString2 = newDatett.toISOString().slice(0, 10);
                         if (skipDates.includes(dateString2)) {
                              var newDate =  new Date(endDateoutus.getTime() + (2 * 86400000));
                         
                             var newDatettt =  new Date(endDateoutus.getTime() + (3 * 86400000));
                             var dateString3 = newDatettt.toISOString().slice(0, 10);
                        
                             if (skipDates.includes(dateString3)) {
                               
                               var newDate =  new Date(endDateoutus.getTime() + (3 * 86400000));
                               var newDatettttt =  new Date(endDateoutus.getTime() + (4 * 86400000));
                                 var dateString4 = newDatettttt.toISOString().slice(0, 10);
                                if (skipDates.includes(dateString4)) {
                                var newDate =  new Date(endDateoutus.getTime() + (4 * 86400000));
                                }  
                             }
                         }
                        }
      
                                  
                              var newdd = newDate.getDate();
                              var newmm = newDate.getMonth() + 1;
                              let day = weekday[newDate.getDay()];

                           if(newdd == "1" || newdd == "21" || newdd == "31"){
                                var dayt = newdd+'st';
                              } else if(newdd == "2" || newdd == "22"){
                                 var dayt = newdd+'nd';
                              } else if(newdd == "3" || newdd == "33"){
                                var dayt = newdd+'rd';
                              } else{
                                var dayt = newdd+'th';
                              }

                           
                            
                              var finalDate = day+', '+monthNames[newDate.getMonth()] + ' ' +newdd ;
                            
                 
                           
                  
                 }

                   var endDateSpecial = $('.end_date_sp').text();
                   var startDateSpecial = $('.start_date_sp').text();
                   var date2 = new Date(endDateSpecial);
                   var date1 = new Date(startDateSpecial);
                   var date3 = new Date(newDate);
                   var date4 = new Date(newDateRange);
              
                if(country_loc == "yes") {  
                if(price < 251 ){
              
                  if (date4 > date1 && date4 <= date2) {
                  document.getElementById('special_ocassion_collection').style.display = 'flex'; 
                     $('.custom_product_collection_title_wrapper').removeClass('hasocassion'); 
                   $('aside').removeClass('spocassion');   
                   $('.tagnewspecial_'+attrpid).css('display', 'flex');
                   $('.Ocassion_data .grid_special_'+attrpid).css('display','flex');
                   $('.Ocassion_data .grid_special_'+attrpid).addClass('showData');

                    $(this).addClass(date4+' '+date1+' '+date2);
                  } else{
                     //  ('.tagnewspecial_'+attrpid).css('display', 'none');
                 
                  }
                  
                } else{
                if (date3 > date1 && date3 < date2) {
                document.getElementById('special_ocassion_collection').style.display = 'flex'; 
                   $('.custom_product_collection_title_wrapper').removeClass('hasocassion'); 
                   $('aside').removeClass('spocassion');   
                  $('.tagnewspecial_'+attrpid).css('display', 'flex');
                  $('.Ocassion_data .grid_special_'+attrpid).css('display','flex');
                  $('.Ocassion_data .grid_special_'+attrpid).addClass('showData');
                   $(this).addClass(date3+' '+date1+' '+date2);
                  } else{
                  
                  }
                 
                }  
                  
                }

                 var counting = $('.grid__item.showData').length;
                  if(counting == 0){
                  //  localStorage.removeItem('specialOccasionValue' + specialOcassioncollection);
                  }
                 $('.filter_count_zeroo').text(`${counting}  Result(s)`);
                  var text = document.createTextNode(finalDate).textContent;
          
                //document.getElementById('est_delivery_date').innerHTML = text;
                //document.getElementById('delivery_date').value = text;  
                 $(this).addClass(text);  
  
})  
}
  
function myfunction() {

setTimeout(function(){   
   
      document.dispatchEvent(new CustomEvent("swym:collections-loaded"));   
  
  },500);

  
 $.ajax({
    url: "https://ipinfo.io/json",
    type: 'GET',
    success: function(res) {
      if(res.country == 'USA' || res.country == 'US'){
         $('.col_card_gift_svg').css('display','block');
          localStorage.setItem('countryus', 'yes');    
       } else{
         $('.col_card_gift_svg').css('display','none');
       }
    }
  });

  
  
// img_load()
//   slick_swap()
 $('.quickViewenabled li.showQuick').css('display','flex');   
$(this).find('.product-grid').addClass('pgrid1');
  
   
$('.slider.slider-products:not(.slick-initialized):not(.ts-snap)').slick({
          dots: true,
          infinite: true,
          responsive: [
          {
            breakpoint: 1024,
            settings: {
             infinite: true,
              dotsClass: 'custom_paging'
             }
          }
        ]    
    });

  $('.popup_gemstone_data ul:not(.slick-initialized)').slick({
        dots: false,
        infinite: false,
        slidesToShow: 5.5,
        slidesToScroll: 3,
     responsive: [
          {
            breakpoint: 767,
            settings: {
            infinite: false,
            slidesToShow: 1.5,
            slidesToScroll: 1,
            }   
          }
        ]
    });
  
}

  
 document.addEventListener("DOMContentLoaded", function() {
    var endlessScroll = new Ajaxinate({
      container: '#Huratips-Loop',
      pagination: '#Huratips-Pagination',
      loadingText: '<div class="host"><div class="loading1 loading-0"></div><div class="loading1 loading-1"></div><div class="loading1 loading-2"></div></div>',
      callback: myfunction
    });
   
  });
   
  document.addEventListener("DOMContentLoaded", function() {
    var endlessScroll = new Ajaxinate({
      container: '#Huratips-Loop2 ul',
      pagination: '#Huratips-Pagination2',
      loadingText: '<div class="host"><div class="loading1 loading-0"></div><div class="loading1 loading-1"></div><div class="loading1 loading-2"></div></div>',
      callback: myfunction1
    });
   
  });  

    document.addEventListener("DOMContentLoaded", function() {
    var endlessScroll = new Ajaxinate({
      container: '#Huratips-Loop3 ul',
      pagination: '#Huratips-Pagination3',
      loadingText: '<div class="host"><div class="loading1 loading-0"></div><div class="loading1 loading-1"></div><div class="loading1 loading-2"></div></div>',
      callback: myfunction
    });
   
  });

   document.addEventListener("DOMContentLoaded", function() {
    var endlessScroll = new Ajaxinate({
      container: '#Huratips-Loop4 ul',
      pagination: '#Huratips-Pagination4',
      loadingText: '<div class="host"><div class="loading1 loading-0"></div><div class="loading1 loading-1"></div><div class="loading1 loading-2"></div></div>',
      callback: myfunction
    });
   
  });

/* ---- from main-collection-product-grid-gemstone-t3.liquid line 3507 ---- */
filterCount();
function filterCount(){

var getCollLen = $('.filter-Birthstone.filter-selected').length;
  if(getCollLen > 0){
var gteTextCol = $('.mobile-facets__summary[data-shape="birthstone"] span.titFilterM').text();
var finalTextResult = `${gteTextCol} (${getCollLen})`
$('.mobile-facets__summary[data-shape="birthstone"] span.titFilterM').text(finalTextResult);
}
  
var getCollLen = $('.filter-Collections.filter-selected').length;
  if(getCollLen > 0){
var gteTextCol = $('.mobile-facets__summary[data-shape="collections"] span.titFilterM').text();
var finalTextResult = `${gteTextCol} (${getCollLen})`
$('.mobile-facets__summary[data-shape="collections"] span.titFilterM').text(finalTextResult);
}
  
var getTypeLen = $('.filter-Type.filter-selected').length;
  if(getTypeLen > 0){
var gteTextType = $('.mobile-facets__summary.focus-inset[data-shape="type"] span.titFilterM').text();
var finalTextResulttype = `${gteTextType} (${getTypeLen})`
$('.mobile-facets__summary.focus-inset[data-shape="type"] span.titFilterM').text(finalTextResulttype);
  }

  var getStyleLen = $('.filter-Style.filter-selected').length;
  if(getStyleLen > 0){
var gteTextStyle = $('.mobile-facets__summary.focus-inset[data-shape="style"] span.titFilterM').text();
var finalTextResultstyle = `${gteTextStyle} (${getStyleLen})`
$('.mobile-facets__summary.focus-inset[data-shape="style"] span.titFilterM').text(finalTextResultstyle);
  }

  var getGemsLen = $('.filter-Gemstone.filter-selected').length;
  if(getGemsLen > 0){
var gteTextGems = $('.mobile-facets__summary.focus-inset[data-shape="gemstone"] span.titFilterM').text();
var finalTextResulGems = `${gteTextGems} (${getGemsLen})`
$('.mobile-facets__summary.focus-inset[data-shape="gemstone"] span.titFilterM').text(finalTextResulGems);
  }

  var getMetLen = $('.filter-Metal.filter-selected').length;
  if(getMetLen > 0){
    var gteTextMetal = $('.mobile-facets__summary.focus-inset[data-shape="metal"] span.titFilterM').text();
    var finalTextResulMetal = `${gteTextMetal} (${getMetLen})`
    $('.mobile-facets__summary.focus-inset[data-shape="metal"] span.titFilterM').text(finalTextResulMetal);
  }

  
}
  



  
var getBirthLen = $('input.mobile-facets__checkbox[name="filter.p.m.my_fields.birthstone"]:checked').length; 
  if(getBirthLen > 0){
var gteText = $('summary.mobile-facets__summary.focus-inset[data-shape="birthstone"] span.titFilterM').text();
var finalText = `${gteText} (${getBirthLen})`
$('summary.mobile-facets__summary.focus-inset[data-shape="birthstone"] span.titFilterM').text(finalText); 
  }
  
var getCollLen = $('input.mobile-facets__checkbox[name="filter.p.m.custom.collection_tag_name"]:checked').length;
  if(getCollLen > 0){
var gteTextCol = $('summary.mobile-facets__summary.focus-inset[data-shape="collections"] span.titFilterM').text();
var finalTextResult = `${gteTextCol} (${getCollLen})`
$('summary.mobile-facets__summary.focus-inset[data-shape="collections"] span.titFilterM').text(finalTextResult);
  }

  var getTypeLen = $('input.mobile-facets__checkbox[name="filter.p.m.my_fields.type"]:checked').length;
  if(getTypeLen > 0){
var gteTextType = $('summary.mobile-facets__summary.focus-inset[data-shape="type"] span.titFilterM').text();
var finalTextResulttype = `${gteTextType} (${getTypeLen})`
$('summary.mobile-facets__summary.focus-inset[data-shape="type"] span.titFilterM').text(finalTextResulttype);
  }
  var getStyleLen = $('input.mobile-facets__checkbox[name="filter.p.m.custom.style_new"]:checked').length;
  if(getStyleLen > 0){
var gteTextStyle = $('summary.mobile-facets__summary.focus-inset[data-shape="style"] span.titFilterM').text();
var finalTextResultstyle = `${gteTextStyle} (${getStyleLen})`
$('summary.mobile-facets__summary.focus-inset[data-shape="style"] span.titFilterM').text(finalTextResultstyle);
  }

  var getGemsLen = $('input.mobile-facets__checkbox[name="filter.p.m.customizer.gemstone_name"]:checked').length;
  if(getGemsLen > 0){
var gteTextGems = $('summary.mobile-facets__summary.focus-inset[data-shape="gemstone"] span.titFilterM').text();
var finalTextResulGems = `${gteTextGems} (${getGemsLen})`
$('summary.mobile-facets__summary.focus-inset[data-shape="gemstone"] span.titFilterM').text(finalTextResulGems);
  }
  var getMetLen = $('input.mobile-facets__checkbox[name="filter.p.m.custom.metal"]:checked').length;
  if(getMetLen > 0){
    var gteTextMetal = $('summary.mobile-facets__summary.focus-inset[data-shape="metal"] span.titFilterM').text();
    var finalTextResulMetal = `${gteTextMetal} (${getMetLen})`
    $('summary.mobile-facets__summary.focus-inset[data-shape="metal"] span.titFilterM').text(finalTextResulMetal);
  }
  

/* ---- from main-collection-product-grid-gemstone-t3.liquid line 3601 ---- */
$('body').on('click','.gemstone_popup_active',function () {
  $('.close_gemstone').click();
})
$('body').on('click','.close_gemstone',function () {
  $('.ajax_popup').html('');
  $('.ajax_popup .popup_gemstone_data ul').slick('unslick');
  $('body').removeClass('active_popup_gemstone');
  $('.jtpl_overlay').removeClass('gemstone_popup_active');
  $('.popup_gemstone_data').removeClass('active_popup');
})
 

/* ---- from main-collection-product-grid-gemstone-t3.liquid line 3618 ---- */
   $(document).on({
     mouseenter: function() {
        console.log("<<<<<<<<<<<<<<<<<<<<<<entered inside gemstone-collevtion now working>>>>>>>>>>>>>>>>>>>>>>")
         var $gridItem = $(this).closest('.grid__item');

        // Original hide
        $gridItem.find('.hover_img_orig').hide();
        // Duplicate show
        $gridItem.find('.hover_img_dup').show();

        $gridItem.find('.hover_img_false').hide();
        $gridItem.find('.hover_img_true').show();

        var selectedpid =    $(this).attr('data-pid');
        var dataType =    $(this).attr('data-type');
        var collectionName =   $(this).attr('data-collection');
        var selectedName =   $(this).attr('data-name');
        var selectedWeight = $(this).attr('data-weight');
        var metal_Name =     $(this).attr('data-metal').trim();
        var size_Name =     $(this).attr('data-size').trim();
        var Option =     $(this).attr('data-option');
       if(collectionName != undefined){
         selectedName =   collectionName+' '+selectedName; 
       } else{
          selectedName =   selectedName;
       }
       
        $(this).parents('.gemstone_loop').find('.gemstone_variant').each(function(){
        var mainppid =   $(this).attr('data-mainpid'); 
        var variantpid =   $(this).attr('data-pid');
          
         if(selectedpid == variantpid){
            $(this).find('.variant-info-gemstone').each(function(){
              
               if(Option == 1){
               var metal_Name_option =  metal_Name;
              } else if(Option == 2 ){
                var metal_Name_option =  metal_Name+' / '+size_Name; 
              }
             
           
             var selectedtitle=   $(this).attr('data-vtitle');
           
             if(selectedtitle == metal_Name_option){
                if(dataType == "Rings" || dataType == "Rings,Wedding Rings"  ){
                var selectedsku =   $(this).attr('data-vsku').split('-')[0];
              } else{
                var selectedsku =   $(this).attr('data-vsku');
              }
                 var selectedPrice  = $(this).attr('data-vprice');
             
                var img_featured = "https://dsv7iunirnrax.cloudfront.net/"+selectedpid+"/"+selectedsku+"-1.jpg"
                $(this).parents('.inventory_detail').find('.titCollection2').text(selectedName);

                console.log(`seeplsetcinted_files007${selectedPrice}`);// working now consoled

                $(this).parents('.inventory_detail').find('.price-item--regular').html(selectedPrice);
             
                 $(this).parents('.inventory_detail').find('.main_slider_image img').not('.hover_img_orig').not('.hover_img_false').attr('src',img_featured);
                 $(this).parents('.inventory_detail').find('.main_slider_image img').not('.hover_img_orig').not('.hover_img_false').attr('data-src',img_featured);
                 $(this).parents('.inventory_detail').find('.main_slider_image img').not('.hover_img_orig').not('.hover_img_false').attr('srcset',img_featured);
             }
           })
         }
       })
  
        
           
    },
    mouseleave: function() {
       var $gridItem = $(this).closest('.grid__item');

        // Original show
        $gridItem.find('.hover_img_orig').show();

        // Duplicate hide
        $gridItem.find('.hover_img_dup').hide();
         $gridItem.find('.hover_img_false').show();
        $gridItem.find('.hover_img_true').hide();
       var selectedName = $(this).parents('.gemstone_loop').find('.jtpl_selected').attr('data-name');
       var collectionName =   $(this).parents('.gemstone_loop').find('.jtpl_selected').attr('data-collection');
       var producttt = $(this).parents('.gemstone_loop').find('.jtpl_selected').attr('data-pid');
       var metalll = $(this).parents('.gemstone_loop').find('.jtpl_selected').attr('data-metal');
       var sizeeee =  $(this).parents('.gemstone_loop').find('.jtpl_selected').attr('data-size').trim();
       var Optionnn =   $(this).parents('.gemstone_loop').find('.jtpl_selected').attr('data-option');
       var dataType =    $(this).parents('.gemstone_loop').find('.jtpl_selected').attr('data-type');
       if(collectionName != undefined){
         selectedName =   collectionName+' '+selectedName; 
        
       } else{
          selectedName =   selectedName;
       }
      if(Optionnn == 1){
         var metal_Name_option =  metalll;
        } else if(Optionnn == 2 ){
          var metal_Name_option =  metalll+' / '+sizeeee; 
        }
     
      $(this).parents('.gemstone_loop').find('.jtpl_selected').prev('.gemstone_variant').each(function(){
        var mainppid =   $(this).attr('data-mainpid'); 
        var variantpid =   $(this).attr('data-pid');
     
         if(producttt == variantpid){
           
            $(this).find('.variant-info-gemstone').each(function(){
            
             
            
             var selectedtitle=   $(this).attr('data-vtitle');
             if(selectedtitle == metal_Name_option){
         
                
                if(dataType == "Rings" || dataType == "Rings,Wedding Rings"  ){
                var selectedsku =   $(this).attr('data-vsku').split('-')[0];
              } else{
                var selectedsku =   $(this).attr('data-vsku');
              }
                 var selectedPrice  = $(this).attr('data-vprice');
                var img_featured = "https://dsv7iunirnrax.cloudfront.net/"+producttt+"/"+selectedsku+"-1.jpg";
                var img_featured1 = "https://dsv7iunirnrax.cloudfront.net/"+producttt+"/"+selectedsku+"-2.jpg";
                 $(this).parents('.inventory_detail').find('.titCollection2').text(selectedName);
                 $(this).parents('.inventory_detail').find('.price-item--regular').html(selectedPrice);
        
               
                 $(this).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="0"] .main_slider_image img').not('.hover_img_orig').not('.hover_img_false').attr('src',img_featured);
                 $(this).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="0"] .main_slider_image img').not('.hover_img_orig').not('.hover_img_false').attr('data-src',img_featured);
                 $(this).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="0"] .main_slider_image img').not('.hover_img_orig').not('.hover_img_false').attr('srcset',img_featured);
                 $(this).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="2"] .main_slider_image img').not('.hover_img_orig').not('.hover_img_false').attr('src',img_featured);
                 $(this).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="2"] .main_slider_image img').not('.hover_img_orig').not('.hover_img_false').attr('data-src',img_featured);
                 $(this).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="2"] .main_slider_image img').not('.hover_img_orig').not('.hover_img_false').attr('srcset',img_featured);

                 $(this).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="-1"] .main_slider_image img').not('.hover_img_orig').not('.hover_img_false').attr('src',img_featured1);
                 $(this).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="-1"] .main_slider_image img').not('.hover_img_orig').not('.hover_img_false').attr('data-src',img_featured1);
                 $(this).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="-1"] .main_slider_image img').not('.hover_img_orig').not('.hover_img_false').attr('srcset',img_featured1);
                 $(this).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="1"] .main_slider_image img').not('.hover_img_orig').not('.hover_img_false').attr('src',img_featured1);
                 $(this).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="1"] .main_slider_image img').not('.hover_img_orig').not('.hover_img_false').attr('data-src',img_featured1);
                 $(this).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="1"] .main_slider_image img').not('.hover_img_orig').not('.hover_img_false').attr('srcset',img_featured1);
             }
           })
         }
       })
         
    },

}, ".gemstone_loop_img");
   

/* ---- from main-collection-product-grid-gemstone-t3.liquid line 3767 ---- */
  $('body').on('click','.gemstone_loop_img',function () {
      $(this).parents('.jtpl-pro-variant-cstm-gem').find('.gemstone_loop_img').removeClass('jtpl_selected');
       $(this).addClass('jtpl_selected');
        var selectedpid =    $(this).attr('data-pid');
        var collectionName =   $(this).attr('data-collection');
        var selectedName =   $(this).attr('data-name');
        var selectedWeight = $(this).attr('data-weight');
        var metal_Name =     $(this).attr('data-metal');
        var handle_Name =     $(this).attr('data-handle');
        var size_Name =     $(this).attr('data-size').trim();
        var Option =     $(this).attr('data-option');
        $(this).parents('.gemstone_loop').find('.gemstone_variant').each(function(){
        var mainppid =   $(this).attr('data-mainpid'); 
        var variantpid =   $(this).attr('data-pid');
        var dataType =    $(this).attr('data-type');
           if(collectionName != undefined){
         selectedName =   collectionName+' '+selectedName; 
       } else{
          selectedName =   selectedName;
       }
         if(selectedpid == variantpid){
            $(this).find('.variant-info-gemstone').each(function(){
               if(Option == 1){
               var metal_Name_option =  metal_Name;
              } else if(Option == 2 ){
                var metal_Name_option =  metal_Name+' / '+size_Name; 
              }
             
            
             var selectedtitle=   $(this).attr('data-vtitle');
              console.log(`datatype=>>>>>>>>>>>>${dataType}`);
             if(selectedtitle == metal_Name_option){
              if (
                    dataType == "Rings" ||
                    dataType == "Rings,Wedding Rings" ||
                    typeof dataType === "undefined"
                  ) {

                    var selectedsku = $(this).attr('data-vsku').split('-')[0];

                  } else {

                    var selectedsku = $(this).attr('data-vsku');

                  }
                                  
                  var selectedPrice  = $(this).attr('data-vprice');
        
                 var img_featured = "https://dsv7iunirnrax.cloudfront.net/"+selectedpid+"/"+selectedsku+"-1.jpg";
                 console.log(`image_feature00256=>${img_featured}`);
                 var img_featured1 = "https://dsv7iunirnrax.cloudfront.net/"+selectedpid+"/"+selectedsku+"-2.jpg";

                  console.log(`image_feature00256=>${img_featured}`);
                 
                 console.log(`image_feature00256 selected sku=>${selectedsku}`);
                $(this).parents('.inventory_detail').find('.slider-jtpl-nav a').attr('href','/products/'+handle_Name);
                $(this).parents('.inventory_detail').find('.titCollection2').attr('href','/products/'+handle_Name);
               
                 $(this).parents('.inventory_detail').find('.titCollection2').text(selectedName);
                 $(this).parents('.inventory_detail').find('.price-item--regular').text(selectedPrice);
                 $(this).parents('.inventory_detail').find('.main_slider_image').attr('data-meta-title',metal_Name);
                 $(this).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="0"] .main_slider_image img').not('.hover_img_dup').attr('src',img_featured);
                 $(this).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="0"] .main_slider_image img').not('.hover_img_dup').attr('data-src',img_featured);
                 $(this).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="0"] .main_slider_image img').not('.hover_img_dup').attr('srcset',img_featured);
                 $(this).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="2"] .main_slider_image img').not('.hover_img_dup').attr('src',img_featured);
                 $(this).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="2"] .main_slider_image img').not('.hover_img_dup').attr('data-src',img_featured);
                 $(this).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="2"] .main_slider_image img').not('.hover_img_dup').attr('srcset',img_featured);

                 $(this).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="-1"] .main_slider_image img').not('.hover_img_dup').attr('src',img_featured1);
                 $(this).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="-1"] .main_slider_image img').not('.hover_img_dup').attr('data-src',img_featured1);
                 $(this).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="-1"] .main_slider_image img').not('.hover_img_dup').attr('srcset',img_featured1);
                 $(this).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="1"] .main_slider_image img').not('.hover_img_dup').attr('src',img_featured1);
                 $(this).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="1"] .main_slider_image img').not('.hover_img_dup').attr('data-src',img_featured1);
                 $(this).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="1"] .main_slider_image img').not('.hover_img_dup').attr('srcset',img_featured1);

                 $(this).parents('.inventory_detail').find('.titCollection2').text(selectedName);
                 $(this).parents('.inventory_detail').find('.price-item--regular').html(selectedPrice);
               
               
             }
           })
         }
       })


})


   function checkImageExists(imageUrl, callback) {
    var img = new Image();
    img.onload = function() {
        // The image loaded successfully
        callback(true);
    };
    img.onerror = function() {
        // The image could not be loaded
        callback(false);
    };
    img.src = imageUrl;
}




  

/* ---- from main-collection-product-grid-gemstone-t3.liquid line 3876 ---- */
/* A thumb tap on "Add to Bag" inside the +N sheet usually drifts a few pixels; slick on the
   sheet's slider reads that as the start of a swipe and nudges the slides before the click lands.
   Keep touches that start on the button away from the slider (capture phase, so slick never
   sees them); the click itself still fires. */
document.addEventListener('touchstart', function (e) {
  if (e.target.closest && e.target.closest('.popup_gemstone_data .add_quick_btn_metal')) e.stopPropagation();
}, { capture: true, passive: true });
document.addEventListener('mousedown', function (e) {
  if (e.target.closest && e.target.closest('.popup_gemstone_data .add_quick_btn_metal')) e.stopPropagation();
}, true);

$(document).on("click", ".popup_gemstone", function() {
    var _this = this;
    var url = $(this).attr('data-url');

    $.ajax({
        url: url,
        type: 'GET',

        success: function(res) {
            $('.ajax_popup').html(res);

            $('.ajax_popup .popup_gemstone_data ul').slick({
                dots: false,
                infinite: false,
                slidesToShow: 4.5,
                slidesToScroll: 4,
                responsive: [{
                    breakpoint: 1200,
                    settings: {
                        infinite: false,
                        slidesToShow: 3.5,
                        slidesToScroll: 3,
                    }
                },
                 {
                    breakpoint: 767,
                    settings: {
                        infinite: false,
                        slidesToShow: 1.5,
                        slidesToScroll: 1,
                    }
                }
                            
        ]
            });
       
    // if ($(window).width() < 768) {
    //     // Initialize the slider if not already initialized
    //     if (!$('.slidergem.slider-productsgem').hasClass('slick-initialized')) {
    //         $('.slidergem.slider-productsgem').slick('unslick');
    //     }
    // } else {
    //     // Destroy the slider if initialized
    //     if ($('.slidergem.slider-productsgem').hasClass('slick-initialized')) {
    //         $('.slidergem.slider-productsgem').slick('unslick');
    //     }
    // }
          
         setTimeout(function(){   
           document.dispatchEvent(new CustomEvent("swym:collections-loaded"));   
          },500);
        }
    });
    $('.jtpl_overlay').addClass('gemstone_popup_active');
    $('body').addClass('active_popup_gemstone');

setTimeout(function(){    
$(".popup_gemstone_data .cstm-hide-select option").each(function() {
var qntyship = $(this).data('qntylessship');
var price = $(this).data('pricee');
var qnty = $(this).data('qnty');
var attrpid = $(this).data('attrpid');  
var skipDates = $('.skipDatesMeta').text();
var qnty_less_data_meta = $('.qnty_less_data_meta').text();
  if(qntyship == null){
   var qnty_less_data = qnty_less_data_meta;
  } else{
  var qnty_less_data = qntyship;       
 } 


  
let wizardInfo = localStorage.getItem('wizardInfo');
if(wizardInfo){
let vendorName = JSON.parse(wizardInfo);
    if(vendorName.vendor_name != undefined || vendorName.vendor_name != null ){
           var url = window.API_URL + `diamonds/diamondShipping/singlevendorShowShipping/${vendorName}`;
        
        var settings = {
          "url": url,
          "method": "GET",
          "timeout": 0,
          "headers": {
          "X-API-Key": "TSANITY121A3VG7NEMVRXXEWGM"
          },
        };
        
        $.ajax(settings).done(function (response) {
        var vendor_Shipping_date = response.shipping_date;

         if(qnty_less_data_meta > vendor_Shipping_date){
          if(qntyship == null){
             var qnty_less_data = qnty_less_data_meta;
            } else{
            var qnty_less_data = qntyship;       
           }  
         }  else{
          
          var qnty_less_data = vendor_Shipping_date;
             
         }
          
        
        });
    }
} 
  if(qnty_less_data == 0){
           qnty_less_data_updated = parseInt(qnty_less_data) + 1;
         } else{
           qnty_less_data_updated = qnty_less_data;
         }
              const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
              "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"
            ];
            
            let today = new Date();
            const pstDate = today.toLocaleString("en-US", { timeZone: "America/New_York" });
            let hh = new Date(pstDate).getHours();
           
             
             if(hh > 15){
               if(qnty_less_data == 0){
              var dd = today.getDate() + 1 ; 
               } else{
               var dd = today.getDate() + 2 ;  
               }
               
             }  else{
               if(qnty_less_data == 0){
              var dd = today.getDate(); 
               } else{
               var dd = today.getDate() + 1 ;  
               }
             }
             
            let mm = today.getMonth() + 1;
            let yyyy = today.getFullYear();
            
            var startDate = yyyy + '/' + mm + '/' + dd;
            startDate = new Date(startDate);
            
            var startDateRange = yyyy + '/' + mm + '/' + dd;
            startDateRange = new Date(startDateRange);

            var startDateOUtUs = yyyy + '/' + mm + '/' + dd;
            startDateOUtUs = new Date(startDateOUtUs); 
            var endDate = "";
            var endDateoutus = "";
            var endDateRange = "";

            var country_loc = localStorage.getItem("countryus");
        
              if(country_loc == 'yes'){
                if(price < 251 ){
                    if(qnty_less_data == 0){
                      var noOfDaysToAdd = parseInt(qnty_less_data_updated) + 2 ; 
                     var noOfDaysToAddrange = parseInt(qnty_less_data_updated) + 5 ; 
                   } else{
                       var noOfDaysToAdd = parseInt(qnty_less_data_updated) + 2 ; 
                     var noOfDaysToAddrange = parseInt(qnty_less_data_updated) + 5 ; 
                   }   
                     
                    
                } else{
                  if(qnty_less_data == 0){
                     var noOfDaysToAdd = parseInt(qnty_less_data_updated) + 1 ;
                     var noOfDaysToAddrange = parseInt(qnty_less_data_updated) + 4 ; 
                   } else{
                      var noOfDaysToAdd = parseInt(qnty_less_data_updated) + 2 ;
                     var noOfDaysToAddrange = parseInt(qnty_less_data_updated) + 5 ; 
                   }   
                     
                }  
            } else{
             
             if(qnty_less_data == 0){
                      var noOfDaysToAddoutusa = parseInt(qnty_less_data_updated) + 1;  
                   } else{
                      var noOfDaysToAddoutusa = qnty_less_data_updated; 
                   }   
              }
            var countoutus = 0;
            while(countoutus < noOfDaysToAddoutusa ){
                endDateoutus = new Date(startDateOUtUs.setDate(startDateOUtUs.getDate() + 1)); 
               if (skipDates.includes(endDateoutus.toISOString().substring(0, 10))) {
                   continue;
              }
              if (endDateoutus.getDay() != 0 && endDateoutus.getDay() != 6 &&  !skipDates.includes(startDateOUtUs.toISOString().substring(0, 10))) {

                  countoutus++;
                }
             }
            
            var count = 0;
            while(count < noOfDaysToAdd ){
                endDate = new Date(startDate.setDate(startDate.getDate() + 1)); 
               if (skipDates.includes(endDate.toISOString().substring(0, 10))) {
                   continue;
              }
              if (endDate.getDay() != 0 && endDate.getDay() != 6 &&  !skipDates.includes(startDate.toISOString().substring(0, 10))) {
                 
                  count++;
                }
             }

              var count1 = 0;
              while(count1 < noOfDaysToAddrange ){
                endDateRange = new Date(startDateRange.setDate(startDateRange.getDate() + 1)); 
               if (skipDates.includes(endDateRange.toISOString().substring(0, 10))) {
                   continue;
              }
              if (endDateRange.getDay() != 0 && endDateRange.getDay() != 6 &&  !skipDates.includes(startDateRange.toISOString().substring(0, 10))) {
                  
                  count1++;
                }
             }
       
            const weekday = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];   
           
            
              
               var country_loc = localStorage.getItem("countryus");
           
              
                if(country_loc == "yes") {
                 console.log("<<<<<<<<<<<<<<<<selected country yess>>>>>>>>>>>>>>>>");
                    var newDateRange =  new Date(endDateRange.getTime());

                    var newDaten =  new Date(endDateRange.getTime() + (1 * 86400000));
                      var skipDates = $('.skipDatesMeta').text();
                     
                       var dateString = newDaten.toISOString().slice(0, 10);
                    
                       if (skipDates.includes(dateString)) {
                      
                          var newDateRange =  new Date(endDateRange.getTime() + (1 * 86400000));
                          var newDatett =  new Date(endDateRange.getTime() + (2 * 86400000));   
                          var dateString2 = newDatett.toISOString().slice(0, 10);
                         if (skipDates.includes(dateString2)) {
                              var newDateRange =  new Date(endDateRange.getTime() + (2 * 86400000));
                         
                             var newDatettt =  new Date(endDateRange.getTime() + (3 * 86400000));
                             var dateString3 = newDatettt.toISOString().slice(0, 10);
                        
                             if (skipDates.includes(dateString3)) {
                               
                               var newDateRange =  new Date(endDateRange.getTime() + (3 * 86400000));
                               var newDatettttt =  new Date(endDateRange.getTime() + (4 * 86400000));
                                 var dateString4 = newDatettttt.toISOString().slice(0, 10);
                                if (skipDates.includes(dateString4)) {
                                var newDateRange =  new Date(endDateRange.getTime() + (4 * 86400000));
                                }  
                             }
                         }
                        }
                 
                   var newDate =  new Date(endDate.getTime());
            
                    var newDaten =  new Date(endDate.getTime() + (1 * 86400000));
                      var skipDates = $('.skipDatesMeta').text();
                     
                       var dateString = newDaten.toISOString().slice(0, 10);
                    
                       if (skipDates.includes(dateString)) {
                         
                      
                          var newDate =  new Date(endDate.getTime() + (1 * 86400000));
                          var newDatett =  new Date(endDate.getTime() + (2 * 86400000));   
                          var dateString2 = newDatett.toISOString().slice(0, 10);
                         if (skipDates.includes(dateString2)) {
                              var newDate =  new Date(endDate.getTime() + (2 * 86400000));
                         
                             var newDatettt =  new Date(endDate.getTime() + (3 * 86400000));
                             var dateString3 = newDatettt.toISOString().slice(0, 10);
                        
                             if (skipDates.includes(dateString3)) {
                               
                               var newDate =  new Date(endDate.getTime() + (3 * 86400000));
                               var newDatettttt =  new Date(endDate.getTime() + (4 * 86400000));
                                 var dateString4 = newDatettttt.toISOString().slice(0, 10);
                                if (skipDates.includes(dateString4)) {
                                var newDate =  new Date(endDate.getTime() + (4 * 86400000));
                                }  
                             }
                         }
                        }
                          
            
                              var newddRange = newDateRange.getDate();
                              var newmmRange = newDateRange.getMonth() + 1;
                              let dayRange = weekday[newDateRange.getDay()];
                             
                                  
                              var newdd = newDate.getDate();
                              var newmm = newDate.getMonth() + 1;
                              let day = weekday[newDate.getDay()];

                           if(newdd == "1" || newdd == "21" || newdd == "31"){
                                var dayt = newdd+'st';
                              } else if(newdd == "2" || newdd == "22"){
                                 var dayt = newdd+'nd';
                              } else if(newdd == "3" || newdd == "33"){
                                var dayt = newdd+'rd';
                              } else{
                                var dayt = newdd+'th';
                              }

                            if(newddRange == "1" || newddRange == "21" || newddRange == "31"){
                                var daytrange = newddRange+'st';
                              } else if(newddRange == "2" || newddRange == "22"){
                                 var daytrange = newddRange+'nd';
                              } else if(newddRange == "3" || newddRange == "33"){
                                var daytrange = newddRange+'rd';
                              } else{
                                var daytrange = newddRange+'th';
                              }

                            if(price < 251 ){
                               var finalDate = day+', '+monthNames[newDate.getMonth()] + ' ' +newdd +' - '+dayRange+', '+monthNames[newDateRange.getMonth()] + ' ' +daytrange;
                            } else{
                              var finalDate = day+', '+monthNames[newDate.getMonth()] + ' ' +dayt ;
                            }  
                 
                            var text = document.createTextNode(finalDate);
                                  
                  
                } else{
            
             
                   var newDate =  new Date(endDateoutus.getTime());
           
                    var newDaten =  new Date(endDateoutus.getTime() + (1 * 86400000));
                      var skipDates = $('.skipDatesMeta').text();
                     
                       var dateString = newDaten.toISOString().slice(0, 10);
                    
                       if (skipDates.includes(dateString)) {
                      
                          var newDate =  new Date(endDateoutus.getTime() + (1 * 86400000));
                          var newDatett =  new Date(endDateoutus.getTime() + (2 * 86400000));   
                          var dateString2 = newDatett.toISOString().slice(0, 10);
                         if (skipDates.includes(dateString2)) {
                              var newDate =  new Date(endDateoutus.getTime() + (2 * 86400000));
                         
                             var newDatettt =  new Date(endDateoutus.getTime() + (3 * 86400000));
                             var dateString3 = newDatettt.toISOString().slice(0, 10);
                        
                             if (skipDates.includes(dateString3)) {
                               
                               var newDate =  new Date(endDateoutus.getTime() + (3 * 86400000));
                               var newDatettttt =  new Date(endDateoutus.getTime() + (4 * 86400000));
                                 var dateString4 = newDatettttt.toISOString().slice(0, 10);
                                if (skipDates.includes(dateString4)) {
                                var newDate =  new Date(endDateoutus.getTime() + (4 * 86400000));
                                }  
                             }
                         }
                        }
      
                                  
                              var newdd = newDate.getDate();
                              var newmm = newDate.getMonth() + 1;
                              let day = weekday[newDate.getDay()];

                           if(newdd == "1" || newdd == "21" || newdd == "31"){
                                var dayt = newdd+'st';
                              } else if(newdd == "2" || newdd == "22"){
                                 var dayt = newdd+'nd';
                              } else if(newdd == "3" || newdd == "33"){
                                var dayt = newdd+'rd';
                              } else{
                                var dayt = newdd+'th';
                              }

                           
                            
                              var finalDate = day+', '+monthNames[newDate.getMonth()] + ' ' +newdd ;
                            
                 
                           
                  
                 }

                   var endDateSpecial = $('.end_date_sp').text();
                   var startDateSpecial = $('.start_date_sp').text();
                   const date2 = new Date(endDateSpecial);
                   const date1 = new Date(startDateSpecial);
                   const date3 = new Date(newDate);
                   const date4 = new Date(newDateRange);
              
                if(country_loc == "yes") {  
                if(price < 251 ){
              
                  if (date4 > date1 && date4 <= date2) {
                  document.getElementById('special_ocassion_collection').style.display = 'flex';   
                   $('.tagnewspecial_'+attrpid).css('display', 'flex');
                   $('.Ocassion_data .grid_special_'+attrpid).css('display','flex');
                   $('.Ocassion_data .grid_special_'+attrpid).addClass('showData');

                    $(this).addClass(date4+' '+date1+' '+date2);
                  } else{
                     //  ('.tagnewspecial_'+attrpid).css('display', 'none');
                 
                  }
                  
                } else{
                if (date3 > date1 && date3 < date2) {
                document.getElementById('special_ocassion_collection').style.display = 'flex'; 
                  $('.tagnewspecial_'+attrpid).css('display', 'flex');
                  $('.Ocassion_data .grid_special_'+attrpid).css('display','flex');
                  $('.Ocassion_data .grid_special_'+attrpid).addClass('showData');
                   $(this).addClass(date3+' '+date1+' '+date2);
                  } else{
                  
                  }
                 
                }  
                  
                }

                 const counting = $('.grid__item.showData').length;
                  if(counting == 0){
                    localStorage.removeItem('specialOccasionValue' + specialOcassioncollection);
                  }
                 $('.filter_count_zeroo').text(`${counting}  Result(s)`);
                  var text = document.createTextNode(finalDate).textContent;
          
                //document.getElementById('est_delivery_date').innerHTML = text;
                //document.getElementById('delivery_date').value = text;  
                 $(this).addClass(text);  
  
})
    },1500);
  
  document.addEventListener("swym:collections-loaded", function(){
     // swat.initializeActionButtons(".ajax_popup");
    })
     
})
   
  //  img_load()
  // slick_swap()
//   function img_load(){
//   ScrollOut({
//    targets: '.p-img', 
//    once: true,
//    onShown: function(el) {
//           $(el).each(function(){
//           var src_data = $(el).attr('data_src');
//           setTimeout(function(){
//           $(el).attr('src',src_data);
//        },300)
//       })
//    }

// })
//   }
// function slick_swap(){
//  $('.slider-products').on('beforeChange', function(event, slick, currentSlide) {
//       $(this).find('.jtpl_sp .p-img').each(function(){
//      var main_src = $(this).attr('data_src');
//         console.log(main_src);
//          $(this).attr('src',main_src);
//     })
//   });
// }

/* ---- from main-collection-product-grid-gemstone-t3.liquid line 2625 ---- */
function initGridItemHover($gridItem) {

    var $original = $gridItem.find(".hover_img_orig");
    var $duplicate = $gridItem.find(".hover_img_dup");

    // New images
    var $hoverFalse = $gridItem.find(".hover_img_false");
    var $hoverTrue = $gridItem.find(".hover_img_true");

    var $variant = $gridItem.find(
        ".jtpl-pro-variant-cstm, .jtpl-pro-variant-cstm-gem"
    );

    // ==========================================
    // INITIAL STATE
    // ==========================================

    $duplicate.attr("style","display:none");
    $original.attr("style","display:block");

    $hoverTrue.attr("style","display:block");
    $hoverFalse.attr("style","display:none");

    // Avoid duplicate events
    $gridItem.off("mouseenter.gridHover mouseleave.gridHover");
    $variant.off("mouseenter.gridHover mouseleave.gridHover");


    // ==========================================
    // GRID ITEM HOVER
    // ==========================================

    $gridItem.on("mouseenter.gridHover", function () {

        if ($gridItem.hasClass('loaded')) {
            return;
        }

        // Original / Duplicate
        $duplicate.attr("style","display:block");
        $original.attr("style","display:none");

        // False / True
        $hoverFalse.attr("style","display:block");
        $hoverTrue.attr("style","display:none");

        $gridItem.addClass("is-hovered");

    });


    // ==========================================
    // GRID ITEM LEAVE
    // ==========================================

    $gridItem.on("mouseleave.gridHover", function () {

        // Original / Duplicate
       $duplicate.attr("style","display:none");
    $original.attr("style","display:block");

    $hoverTrue.attr("style","display:block");
    $hoverFalse.attr("style","display:none");

        $gridItem.removeClass("is-hovered");

    });


    // ==========================================
    // VARIANT / GEMSTONE HOVER
    // ==========================================

    $variant.on("mouseenter.gridHover", function () {

        if ($gridItem.hasClass('loaded')) {
            return;
        }

        // Original / Duplicate -> ULTA
        $duplicate.hide();
        $original.show();

        // False / True -> ULTA
        $hoverTrue.hide();
        $hoverFalse.show();

    });


    // ==========================================
    // VARIANT / GEMSTONE LEAVE
    // ==========================================

    $variant.on("mouseleave.gridHover", function () {

        if (
            $gridItem.is(":hover") &&
            !$gridItem.hasClass('loaded')
        ) {

            // Original / Duplicate
            $duplicate.show();
            $original.hide();

            // False / True
            $hoverFalse.hide();
            $hoverTrue.show();

        }

    });


    // ==========================================
    // LOADER REMOVE
    // ==========================================

    setTimeout(function () {

        $gridItem.removeClass('loaded');

        // Mouse abhi bhi grid ke upar hai?
        if ($gridItem.is(":hover")) {

            // Original / Duplicate
            $duplicate.show();
            $original.hide();

            // False / True
            $hoverFalse.show();
            $hoverTrue.hide();

            $gridItem.addClass("is-hovered");

        }

    }, 700);
}


// Initial page load
$(".grid__item").each(function () {

    initGridItemHover($(this));

});

$(document).on('click', '.load-more-product', function () {

  var interval = setInterval(function () {
   
    if ($('.load-more-product .host').length === 0) {
      
      clearInterval(interval);

      $(".grid__item").each(function () {
        initGridItemHover($(this));
      });

    }

  }, 100);

});
// Gemstone click
$(document).on('click', '.gemstone_loop', function (e) {

    // The "+N" more-options button sits inside the swatch row; its own handler opens the popup,
    // nothing about the card changes, so don't re-fetch and rebuild the card's image strip.
    if (e && e.target && $(e.target).closest('.popup_gemstone').length) return;

    var $gridItem = $(this).closest('.grid__item');
    var $selected = $gridItem.find('.jtpl_selected');

    var selectedPid = $selected
        .closest('.gemstone_loop')
        .attr('data-pid');

    var selectedHandle = ($selected
        .closest('.gemstone_loop')
        .find('.gemstone_loop_img')
        .attr('data-handle') || '')
        .trim();

    console.log('PID:', selectedPid);
    console.log('Handle:', selectedHandle);

    let url = `/products/${selectedHandle}?view=collection_product_change`;

    console.log('FINAL URL:', url);


    // ==========================================
    // LOADER START
    // ==========================================

    $gridItem.addClass('loaded');


    $.ajax({

        url: url,
        method: 'GET',
        dataType: 'html',

        success: function (ajax_data) {

            var data = $(ajax_data)
                .find('.ajax_data')
                .html();

            console.log('AJAX DATA:', data);


            // Current grid item ka slider
            var $slider = $gridItem.find('.slider.slider-products');

            if (!$slider.length) {

                console.log('Slider not found');

                // Loader hata do
                $gridItem.removeClass('loaded');

                // Hover functionality chala do
                initGridItemHover($gridItem);

                return;
            }


            // Existing slick destroy
            if ($slider.hasClass('slick-initialized')) {
                $slider.slick('unslick');
            }


            // New AJAX data insert
            $slider.html(data);

            // Scroll-snap strip (ts-card-slider.css): the new slides are already a working strip,
            // no slick needed; just drop the loader and re-arm the hover handlers.
            if ($slider.hasClass('ts-snap')) {
                $gridItem.removeClass('loaded');
                initGridItemHover($gridItem);
                return;
            }


            // Slick initialize
            setTimeout(function () {

                $slider.slick({

                    dots: true,
                    infinite: true,

                    responsive: [{
                        breakpoint: 1024,

                        settings: {
                            infinite: true,
                            dotsClass: 'custom_paging'
                        }
                    }]

                });


                // ==========================================
                // LOADER END
                // ==========================================




                // ==========================================
                // HOVER FUNCTIONALITY START
                // ==========================================

                initGridItemHover($gridItem);


            }, 100);

        },


        error: function (xhr, status, error) {

            console.log('AJAX FAILED');
            console.log('Status:', xhr.status);
            console.log('Status Text:', xhr.statusText);
            console.log('Error:', error);
            console.log('Response:', xhr.responseText);


            // Error hone par bhi loader hatao
            $gridItem.removeClass('loaded');

            // Hover functionality wapas enable
            initGridItemHover($gridItem);

        }

    });

});




$(document).on('click', '.jtpl-variant-img', function () {

    /* var $gridItem = $(this).closest('.grid__item');
    var $selected = $gridItem.find('.jtpl_selected');

    var selected_var_id = ($selected
        .attr('data-variant-id') || '')
        .trim();

    var selectedHandle = ($selected
        .attr('data-handle') || '')
        .trim();

    console.log('Variant ID:', selected_var_id);
    console.log('Handle:', selectedHandle);

    if (!selected_var_id) {
        console.log('Variant ID missing');
        return;
    }

    if (!selectedHandle) {
        console.log('Handle missing');
        return;
    }

    let url = `/products/${selectedHandle}?variant=${selected_var_id}&view=collection_product_change_variant`;

    console.log('FINAL URL:', url);

    $gridItem.addClass('loaded'); 

    $.ajax({

        url: url,
        type: 'GET',
        dataType: 'html',

        success: function (ajax_data) {

            console.log('AJAX SUCCESS');

            var data = $(ajax_data)
                .find('.ajax_data')
                .html();

            console.log('AJAX DATA:', data);
            var $slider = $gridItem.find('.slider.slider-products');

            if (!$slider.length) {

                console.log('Slider not found');

                // Loader hata do
                $gridItem.removeClass('loaded');

                // Hover functionality chala do
                initGridItemHover($gridItem);

                return;
            }


            // Existing slick destroy
            if ($slider.hasClass('slick-initialized')) {
                $slider.slick('unslick');
            }


            // New AJAX data insert
            $slider.html(data);


            // Slick initialize
            setTimeout(function () {

                $slider.slick({

                    dots: true,
                    infinite: true,

                    responsive: [{
                        breakpoint: 1024,

                        settings: {
                            infinite: true,
                            dotsClass: 'custom_paging'
                        }
                    }]

                });


                // ==========================================
                // LOADER END
                // ==========================================

               


                // ==========================================
                // HOVER FUNCTIONALITY START
                // ==========================================

                initGridItemHover($gridItem);
                 

            }, 100);
        },

        error: function (xhr, status, error) {

            console.log('AJAX ERROR');
            console.log('Status:', status);
            console.log('HTTP Status:', xhr.status);
            console.log('Error:', error);
            console.log('Response:', xhr.responseText);

            $gridItem.removeClass('loaded');
        },

        complete: function () {

            console.log('AJAX COMPLETE');

        }

    }); */

});
